import type { JSX } from 'react';
import { ExternalLinkIcon } from '@radix-ui/react-icons';
import { EMPTY_VALUE, toWebsiteHref, toWebsiteLabel } from './tenantProfileData';

interface WebsiteLinkProps {
  website: string;
}

export function WebsiteLink({ website }: WebsiteLinkProps): JSX.Element {
  const href = toWebsiteHref(website);
  if (href.length === 0) {
    return <span className="text-text-primary/40">{EMPTY_VALUE}</span>;
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      className="inline-flex items-center gap-1 font-medium text-brand-primary underline-offset-2 hover:underline"
    >
      {toWebsiteLabel(website)}
      <ExternalLinkIcon className="h-3.5 w-3.5" aria-hidden />
    </a>
  );
}
